import { render, staticRenderFns } from "./EnterTheGame.vue?vue&type=template&id=33b9e6fd&scoped=true"
import script from "./EnterTheGame.vue?vue&type=script&lang=js"
export * from "./EnterTheGame.vue?vue&type=script&lang=js"
import style0 from "./EnterTheGame.vue?vue&type=style&index=0&id=33b9e6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9e6fd",
  null
  
)

export default component.exports